<template>
  <FormContainer :add-back-click-listener="false" redirect-to-path="/ofertas">
    <ColdOfferVehicleQuestionsFormInteractive
      :busy="busy"
      @submit="submit"
      @back="$emit('back')"
    />
  </FormContainer>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import ColdOfferVehicleQuestionsFormInteractive from '@/components/forms/loans/auto/cold-offer/interactive/AutoColdOfferVehicleQuestionsFormInteractive.vue'
import FormContainer from '@/containers/forms/FormContainer.vue'
export default {
  name: 'AutoColdOfferInteractiveFormContainer',
  components: {
    ColdOfferVehicleQuestionsFormInteractive,
    FormContainer,
  },
  props: {
    simulationSource: {
      type: String,
      default: 'onboarding_auto',
    },
  },
  emits: ['back', 'submit'],
  data() {
    return {
      busy: false,
    }
  },
  computed: {
    ...mapGetters({
      gtUser: 'user/user/gtUser',
      personaData: 'user/persona/personaData',
      gtCreditScoreLatest:
        'products/credit-score/credit-score/gtCreditScoreLatest',
    }),
  },
  mounted() {
    this.actCreditScoreGetLatest()
  },
  methods: {
    ...mapActions({
      createFeedback: 'utils/feedback/createFeedback',
      actSubmitAutoColdOffer:
        'products/loans/auto-equity/cold-offer/actSubmitAutoColdOffer',
      actSetLastLoanInteraction: 'ui/user-activity/actSetLastLoanInteraction',
      actCreditScoreGetLatest:
        'products/credit-score/credit-score/actCreditScoreGetLatest',
    }),
    async submit(vehicleQuestions) {
      this.busy = true
      const coldOfferRequest = {
        birth_date: this.personaData?.info?.birth_date ?? '',
        email: this.gtUser.email,
        mobile_phone: this.gtUser.mobile_phone,
        cpf: this.gtUser.cpf,
        name: this.gtUser.name,
        vehicle: vehicleQuestions,
        score: this.gtCreditScoreLatest?.data?.score,
        simulation_source: this.simulationSource,
      }

      const response = await this.actSubmitAutoColdOffer(coldOfferRequest)
      if (response?.status === 200) {
        this.actSetLastLoanInteraction('auto-equity')
        this.$emit('submit', coldOfferRequest)
      } else {
        this.createFeedback({
          text: 'Algo deu errado! Por favor tente novamente.',
        })
      }
      this.busy = false
    },
  },
}
</script>
<style lang="scss"></style>
